export default  {
    name: 'नाम',
    tel: 'TELEPHONE',
    save: 'बचा ले',
    confirm: 'पुष्टि करें',
    cancel: 'रद्द करना',
    delete: 'हटाना',
    complete: 'खत्म हो',
    loading: 'लोड हो रहा है...',
    telEmpty: 'कृपया फोन भरें',
    nameEmpty: 'कृपया आपका नाम दर्ज करें',
    nameInvalid: 'कृपया सही नाम दर्ज करें',
    confirmDelete: 'आप वाकई इसे हटाना चाहते हैं',
    telInvalid: 'एक मान्य दूरभाष क्रमांक दर्ज करे',
    vanCalendar: {
        end: 'समाप्त',
        start: 'शुरू',
        title: 'तिथि चयन',
        confirm: 'ठानना',
        startEnd: 'अंत शुरू',
        weekdays: ['दिन', 'एक', 'दो', 'तीन', 'चार', 'पांच', 'छः'],
        monthTitle: function monthTitle(year, month) {
            return year + "\u5E74" + month + "\u6708";
        },
        rangePrompt: function rangePrompt(maxRange) {
            return "\u9009\u62E9\u5929\u6570\u4E0D\u80FD\u8D85\u8FC7 " + maxRange + " \u5929";
        }
    },
    vanCascader: {
        select: 'कृपया चुनें'
    },
    vanContactCard: {
        addText: 'संपर्क जोड़ें'
    },
    vanContactList: {
        addText: 'नया कॉन्ट्रैक्ट'
    },
    vanPagination: {
        prev: 'पिछला पृष्ठ',
        next: 'अगला पृष्ठ'
    },
    vanPullRefresh: {
        pulling: 'ताज़ा करने के लिए नीचे खींचें...',
        loosing: 'ताज़ा होने के लिए छोड़ दें...'
    },
    vanSubmitBar: {
        label: 'संपूर्ण：'
    },
    vanCoupon: {
        unlimited: 'कोई उपयोग सीमा नहीं',
        discount: function discount(_discount) {
            return _discount + "\u6298";
        },
        condition: function condition(_condition) {
            return "\u6EE1" + _condition + "\u5143\u53EF\u7528";
        }
    },
    vanCouponCell: {
        title: 'कूपन',
        tips: 'अनुपलब्ध',
        count: function count(_count) {
            return _count + "\u5F20\u53EF\u7528";
        }
    },
    vanCouponList: {
        empty: 'कोई कूपन नहीं',
        exchange: 'लेन देन',
        close: 'कोई कूपन नहीं',
        enable: 'उपलब्ध',
        disabled: 'अनुपलब्ध',
        placeholder: 'कृपया कूपन कोड दर्ज करें'
    },
    vanAddressEdit: {
        area: 'क्षेत्र',
        postal: 'डाक कोड',
        areaEmpty: 'कृपया क्षेत्र का चयन करें',
        addressEmpty: 'कृपया विस्तृत पता भरें',
        postalEmpty: 'गलत पोस्टल कोड प्रारूप',
        defaultAddress: 'शिपिंग पता डिफ़ॉल्ट रूप में सेट करें',
        telPlaceholder: 'प्रेषिती का मोबाइल फोन नंबर',
        namePlaceholder: 'प्रेषिती का नाम',
        areaPlaceholder: 'प्रांत / शहर / जिले का चयन करें'
    },
    vanAddressEditDetail: {
        label: 'पता',
        placeholder: 'गली नंबर, फ्लोर रूम नंबर और अन्य जानकारी'
    },
    vanAddressList: {
        add: 'पता जोड़ें'
    }
};
